import { apiRequest } from './apiClient.js'

export const usersService = {
  list: (options = {}) => apiRequest('/api/users/list', options),
  info: (options = {}) => apiRequest('/api/user/info', options),
  avatar: (userId, options = {}) => apiRequest(`/api/users/${encodeURIComponent(userId)}/avatar`, options),
  remove: (userId, options = {}) => apiRequest(`/api/users/${encodeURIComponent(userId)}`, options),
  createTest: (options = {}) => apiRequest('/api/users/create-test', options),
  removeAll: (options = {}) => apiRequest('/api/users/delete-all', options),
  adminList: (options = {}) => apiRequest('/api/admin/users/list', options),
  adminAvatar: (userId, options = {}) => apiRequest(`/api/admin/users/${encodeURIComponent(userId)}/avatar`, options),
}
